import { Component, Input } from '@angular/core';
import { TOOLTIP } from 'src/app/core/constants/tooltip.constants';

@Component({
  selector: 'app-app-wizard-percent',
  templateUrl: './app-wizard-percent.component.html',
  styleUrls: ['./app-wizard-percent.component.scss']
})
export class AppWizardPercentComponent {

  @Input() percentageComplete:number = 0;
  @Input() deadlineRemain:number = 0;
  @Input() deadlineTotal:number = 0;

  TOOLTIP = TOOLTIP;

}
